import { Link, useParams } from "react-router-dom";
import Seo from "@/components/Seo";
import { Eyebrow, StatusChip } from "@/components/Type";
import { useWaitlist } from "@/context/waitlist";
import { articleBySlug } from "@/content/articles";

export default function ArticlePage() {
  const { slug } = useParams();
  const article = articleBySlug(slug);
  const openWaitlist = useWaitlist();

  if (!article) {
    return (
      <section className="px-6 py-40 text-center">
        <Seo title="Not found | W8ED" description="This piece does not exist." path={`/thinking/${slug}`} />
        <h1 className="font-display text-3xl font-extrabold text-[#f5f2ea]">NOTHING HERE.</h1>
        <Link
          to="/thinking"
          className="mt-8 inline-block font-mono text-[10px] tracking-[0.3em] text-[#C9A227]"
        >
          ← BACK TO THINKING
        </Link>
      </section>
    );
  }

  return (
    <article className="px-6 pb-32 pt-32 sm:pt-40">
      <Seo
        title={`${article.title} | W8ED Thinking`}
        description={article.excerpt}
        path={`/thinking/${article.slug}`}
      />
      <div className="mx-auto max-w-3xl">
        <Link
          to="/thinking"
          data-testid="article-back"
          className="font-mono text-[10px] tracking-[0.3em] text-[#57534a] transition-colors hover:text-[#C9A227]"
        >
          ← W8ED THINKING
        </Link>
        <div className="mt-10 flex flex-wrap items-center gap-4">
          <Eyebrow>{article.topic}</Eyebrow>
          <StatusChip status={article.status} />
        </div>
        <h1 className="mt-8 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-[#f5f2ea] sm:text-6xl">
          {article.title}
        </h1>
        <p className="mt-8 border-l-2 border-[#C9A227] pl-6 text-lg leading-relaxed text-[#b8b3a6]">
          {article.excerpt}
        </p>
        <div className="mt-16 border-t border-[#1f1e1a] pt-10">
          <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#8e8a80]">
            This piece is being written.
          </p>
          <p className="mt-4 text-sm leading-relaxed text-[#57534a]">
            W8ED publishes when there is something worth saying. Join the W8LIST and it will find
            you when it's ready.
          </p>
          <button
            type="button"
            data-testid="article-join"
            onClick={openWaitlist}
            className="mt-8 border border-[#3a3524] px-6 py-3 font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9A227] transition-colors hover:border-[#C9A227]"
          >
            JOIN THE W8LIST
          </button>
        </div>
      </div>
    </article>
  );
}
